var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBocconiHeaderWithLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BocconiHeader",
    width: "100%",
    viewBox: "0 0 1366.357 61.82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4",
    "data-name": "Rettangolo 4",
    width: 1366.357,
    height: 61.82,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4-3",
    "data-name": "Rettangolo 4",
    width: 1366.3571,
    height: 61.82,
    fill: "none",
    x: 0,
    y: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1",
    "data-name": "Rettangolo 1",
    width: 1366.357,
    height: 61.82
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "matrix(0.39576594,0,0,0.39576594,661.00178,8.7372131)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 106.41,13.51 C 103.7,12 100.97,10.53 98.21,9.08 l 1.55,-9.09 12.31,6.93 -5.66,6.57 v 0 z m -16.9,23.5 1.21,8.79 20.48,4.48 0.87,-14.09 -11.76,-10.27 6.02,-9.01 -11.26,-6.05 -2.69,10.64 -21.27,5.92 -5.2,10.9 8.12,-4.69 15.48,3.4 v 0 z m -29.94,61.49 8.96,-7.55 -1.92,-1.24 -10.74,4.65 3.68,4.11 0.02,0.02 z m 34.74,-4.73 -6.27,5.55 -11.7,-8.69 -11.23,7.81 13.49,13.62 22.21,-4.33 3.9,-13.63 -10.4,-0.34 v 0 z m -83.35,5.72 9.05,-3.05 0.07,-34.44 6.52,-1.46 -0.51,-2.89 -6.24,0.7 0.63,-15.88 11.14,-2.74 1.6,4.43 2.58,-0.68 -1.19,-4.29 -8.4,-3.12 L 14.66,39.36 13.02,58.77 0,60.05 v 4.62 L 12.45,63.2 10.97,99.47 v 0.02 z m 22.43,-39.35 1.97,-2.02 -1.34,-5.05 -4.23,-0.17 -1.12,2.7 -0.05,0.52 2.06,4.15 2.72,-0.12 z m -2.56,32.89 5.4,-1.73 3.12,-3.61 c -0.7,-0.56 -1.48,-1.2 -1.95,-1.6 -0.3,0.16 -2.58,1.52 -2.58,1.52 L 34.11,64.45 29.3,64.66 c -0.09,3.19 -0.45,16.07 -0.64,23.37 l 2.14,5.02 z m 14.53,-4.51 13.65,-4.32 -0.37,-4.13 -3.56,1.57 -0.51,-32.62 -13.33,-4.44 -0.7,13.49 2.95,-0.4 0.87,-6.47 7.11,1.73 -0.1,13.79 -9.69,0.3 -0.4,15.06 4.1,6.47 h -0.02 z m 5.98,-18.56 0.05,0.78 0.24,11.26 -4.22,1.38 -0.7,0.23 -2.14,-5.12 0.26,-7.58 0.05,-0.73 6.47,-0.21 h -0.02 z m 19.94,17.55 4.76,-4.76 -8.33,-32.05 5.93,-7.76 8.28,1.08 0.54,2.63 3.42,-0.05 -0.05,-4.39 -12.98,-3.69 -10.63,9.93 9.13,33.51 -8.45,-2.46 0.14,4.69 8.24,3.31 h 0.02 z m 18.14,6.61 0.56,-4.17 -5.82,-2.61 2.77,-33.01 8.5,0.26 1.32,4.58 2.6,-0.54 -0.59,-4.97 -4.98,-3.38 -11.36,1.12 -2.75,31.86 3,8.14 6.78,2.72 H 89.43 Z M 51.85,38.93 48.4,30.16 43.8,31.4 c 4.79,4.72 6.8,6.67 7.58,7.62 0.12,-0.02 0.28,-0.05 0.45,-0.09 z m 49.83,51.69 7.63,-12.72 -5.05,-14.08 -7.32,0.87 -4.64,13.28 4.11,12.22 5.25,0.45 z m 4.67,-17.18 -7.58,13.19 -1.8,-14.83 3.02,-1.83 6.34,3.47 z",
    id: "path1",
    style: {
      fill: "#ffffff"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2",
    "data-name": "Raggruppa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M49.8,44.345a8,8,0,0,1-4.317-2.238,9.344,9.344,0,0,1-2.745-4.7,12.356,12.356,0,0,1-.13-3.8,9.157,9.157,0,0,1,2.835-5.227,8.82,8.82,0,0,1,3.906-2.473,8.129,8.129,0,0,1,5.719.531,10.181,10.181,0,0,1,4.16,4.388,9.98,9.98,0,0,1,.6,6.509,9.76,9.76,0,0,1-6.511,6.89,10.955,10.955,0,0,1-3.526.12Zm2.394-.17a3.641,3.641,0,0,0,2.795-2.884c.381-1.312.421-1.813.421-5.888,0-3.986-.03-4.526-.34-5.918-.391-1.762-1.061-2.814-2.124-3.315a3.448,3.448,0,0,0-3.906.671,7.158,7.158,0,0,0-1.493,3.766,32.925,32.925,0,0,0-.22,5.668,21.961,21.961,0,0,0,.17,3.715c.391,2.113,1.092,3.335,2.224,3.9a4.294,4.294,0,0,0,.791.3,5.276,5.276,0,0,0,1.682,0Zm49.853.17a8.911,8.911,0,0,1-6.04-4.386,9.635,9.635,0,0,1-.569-8.312,11.127,11.127,0,0,1,3.636-4.456,7.938,7.938,0,0,1,11.058,1.562,9.268,9.268,0,0,1,2.134,4.677,13.86,13.86,0,0,1-.08,3.6,9.838,9.838,0,0,1-1.552,3.515,11.262,11.262,0,0,1-3.536,3.144,9.594,9.594,0,0,1-2.1.691,11.609,11.609,0,0,1-2.945,0Zm2.885-.29c1.692-.6,2.484-2.183,2.7-5.4.09-1.292.09-5.267,0-6.659-.16-2.574-.651-4.186-1.542-5.157a3.369,3.369,0,0,0-3.576-.791c-1.232.441-2.114,1.692-2.555,3.675a33.826,33.826,0,0,0-.421,6.95,13.811,13.811,0,0,0,.731,5.2,4.551,4.551,0,0,0,1.112,1.652,4.058,4.058,0,0,0,1.272.621,5.037,5.037,0,0,0,2.284-.1Zm-36.721.2a7.276,7.276,0,0,1-3.366-1.772,9.742,9.742,0,0,1-1.863-2.554,9.18,9.18,0,0,1-.931-4.316,9.327,9.327,0,0,1,2.765-6.93,7.663,7.663,0,0,1,4.087-2.3,8.484,8.484,0,0,1,3.1.03,5.265,5.265,0,0,1,3.686,3.214c.551,1.782.02,3.465-1.312,4.116a1.779,1.779,0,0,1-1.071.22,1.82,1.82,0,0,1-1.061-.21,2.655,2.655,0,0,1-1.315-3.517c.023-.05.047-.1.073-.148a3.13,3.13,0,0,1,1.362-1.212,2.782,2.782,0,0,1,2.5.35,1.164,1.164,0,0,0,.35.18,4.714,4.714,0,0,0-1.054-1.5,3.818,3.818,0,0,0-1.944-1.162,5.411,5.411,0,0,0-2.224-.07c-1.472.35-2.444,1.532-2.875,3.475a34.174,34.174,0,0,0-.16,9.093c.371,2.473,1.342,3.835,3.065,4.276a6.308,6.308,0,0,0,2.034.04,4.37,4.37,0,0,0,2.735-2.033,6.625,6.625,0,0,0,1.182-3.455c.03-.591.06-.731.15-.731a5.26,5.26,0,0,1-.15,2.263,5.589,5.589,0,0,1-4.517,4.646,10.393,10.393,0,0,1-3.246,0Zm16.257,0a7.392,7.392,0,0,1-4.7-3.375,10.133,10.133,0,0,1-.26-10.184A10.42,10.42,0,0,1,82.3,27.6a7.52,7.52,0,0,1,6.335-1.076A5.2,5.2,0,0,1,90.8,27.882,3.893,3.893,0,0,1,92.123,31a2.828,2.828,0,0,1-1.612,2.8,2,2,0,0,1-.951.15,2.192,2.192,0,0,1-1.592-.511,2.611,2.611,0,0,1-.513-3.658,2.513,2.513,0,0,1,.283-.318,2.28,2.28,0,0,1,1.382-.721,2.957,2.957,0,0,1,2.164.591c.12.09.22.14.22.12a5.072,5.072,0,0,0-.28-.531,6.082,6.082,0,0,0-1.692-1.732,4.841,4.841,0,0,0-3.806-.35,4.1,4.1,0,0,0-2.274,2.974,30.945,30.945,0,0,0-.07,10.4,3.983,3.983,0,0,0,3.025,3.355,5.8,5.8,0,0,0,2.044-.03,4.241,4.241,0,0,0,2.214-1.482,7.067,7.067,0,0,0,1.572-3.986c.04-.571.07-.711.15-.711.24,0-.07,2.213-.471,3.295a5.426,5.426,0,0,1-1.392,2.143,3.832,3.832,0,0,1-1.272.941,5.658,5.658,0,0,1-2.975.631,7.066,7.066,0,0,1-1.813-.1ZM18.4,43.634c0-.13.05-.14,1.742-.14h1.742l-.02-12.548L21.844,18.4l-1.722-.02c-1.472-.02-1.722-.03-1.722-.12s.721-.1,5.83-.1c3.376,0,6.141.03,6.581.07a11.883,11.883,0,0,1,3.906.961,5.456,5.456,0,0,1,3.556,5.558,6.8,6.8,0,0,1-.15,1.1A5.709,5.709,0,0,1,37.1,27.8a7.261,7.261,0,0,1-3.426,2.1c-.581.14-.571.18.07.24a7.357,7.357,0,0,1,2.214.761,7.365,7.365,0,0,1,3.987,4.376,4.568,4.568,0,0,1,.15,1.522A8.986,8.986,0,0,1,40,38.2c-.681,3.094-3.706,5.167-8,5.5-.541.04-3.576.07-7.262.07-6.291,0-6.341,0-6.341-.14Zm13.292-.34a4.151,4.151,0,0,0,2.932-3.766,19.268,19.268,0,0,0,.18-3.885c-.24-2.524-1.422-4.336-3.356-5.107a6.493,6.493,0,0,0-2.855-.361H27.073V43.507l2.064-.03a7.921,7.921,0,0,0,2.545-.18ZM30.6,29.794q3.2-.677,3.025-5.628a6.667,6.667,0,0,0-1.4-4.1,4.059,4.059,0,0,0-1.3-1.152,4.237,4.237,0,0,0-2.565-.561l-1.282-.04V29.885H28.6a11.64,11.64,0,0,0,2-.1Zm84.14,13.829c0-.13.05-.14,1.362-.14h1.362V26.407h-1.532c-1.322,0-1.532-.01-1.532-.1s.471-.1,3.8-.1H122V28.14l.01,1.933.12-.461a5.354,5.354,0,0,1,3.3-3.645,3.549,3.549,0,0,1,1.442-.18,4.7,4.7,0,0,1,3.44,1.22,5.835,5.835,0,0,1,1.722,3.2c.15.671.15.741.18,6.98l.03,6.3h1.5c1.452,0,1.5,0,1.5.14s-.05.14-4.848.14-4.848,0-4.848-.14.05-.14,1.061-.14h1.061v-7.05c0-4.106-.03-7.29-.07-7.631a2.782,2.782,0,0,0-1.041-2.173c-.26-.17-.34-.19-.9-.19a1.7,1.7,0,0,0-1.021.2c-1,.511-1.914,2.013-2.454,4.036-.14.531-.15.671-.17,6.679L122,43.487h1.092c1.051,0,1.092,0,1.092.14s-.05.14-4.718.14-4.718,0-4.718-.14Zm22.818,0c0-.13.05-.14,1.532-.14h1.532V26.407H139.09c-1.322,0-1.532-.01-1.532-.1s.471-.1,3.826-.1h3.826V43.494h1.532c1.492,0,1.532,0,1.532.14s-.05.14-5.358.14-5.358,0-5.358-.14Zm4.327-21.1a2.791,2.791,0,0,1-1.582-1.442,2.025,2.025,0,0,1-.18-1.132,2.009,2.009,0,0,1,.611-1.722,2.849,2.849,0,0,1,3.236-.621,3.189,3.189,0,0,1,1.222,1.272,1.862,1.862,0,0,1,.19,1.112,2.023,2.023,0,0,1-.21,1.162,2.875,2.875,0,0,1-1.252,1.282,3.2,3.2,0,0,1-2.034.1Z",
    transform: "translate(0.005 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M1334.1,23.935l-11.67,20.131-11.679-6.139,2.024-3.495a3.322,3.322,0,0,0,1.387,1.734l8.2,4.3c-2.284-1.322-2.294-5.578-.02-9.493,2.2-3.815,5.76-5.908,8.053-4.807l-8.334-4.4a3.012,3.012,0,0,0-1.733-.381l2.1-3.635,11.669,6.189Z",
    transform: "translate(0.343 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3",
    "data-name": "Tracciato 3",
    d: "M1334.091,23.935v13.97l-11.669,6.159Z",
    transform: "translate(0.346 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4",
    "data-name": "Tracciato 4",
    d: "M1330.389,26.171c-2.294-1.1-5.85,1-8.053,4.807-2.273,3.915-2.264,8.171.02,9.493l-8.194-4.306a3.272,3.272,0,0,1-1.392-1.732c-.761-1.963-.36-5,1.2-7.861,1.682-3.074,4.227-5.057,6.351-5.187a3.027,3.027,0,0,1,1.733.381l8.334,4.4Z",
    transform: "translate(0.343 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M1330.587,26.268l-8.223,14.2c-2.284-1.322-2.294-5.578-.02-9.493,2.2-3.815,5.759-5.908,8.053-4.807l.2.1Z",
    transform: "translate(0.345 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M1330.587,26.268l-8.223,14.2c-2.284-1.322-2.294-5.578-.02-9.493,2.2-3.815,5.759-5.908,8.053-4.807l.2.1Z",
    transform: "translate(0.345 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7",
    "data-name": "Tracciato 7",
    d: "M1132.968,26.539h2.725a5.275,5.275,0,0,1,2.7.531,1.836,1.836,0,0,1,.841,1.682,2.077,2.077,0,0,1-.37,1.282,1.468,1.468,0,0,1-.981.6v.06a1.93,1.93,0,0,1,1.2.691,2.522,2.522,0,0,1-.491,3.214,3.73,3.73,0,0,1-2.344.671h-3.276V26.529ZM1134.822,30h1.071a2.037,2.037,0,0,0,1.091-.23.886.886,0,0,0,.34-.771.775.775,0,0,0-.37-.721,2.308,2.308,0,0,0-1.162-.22h-.971V30Zm0,1.472v2.283h1.212a1.827,1.827,0,0,0,1.132-.29,1.091,1.091,0,0,0,.36-.9c0-.721-.521-1.092-1.552-1.092h-1.152Z",
    transform: "translate(0.296 0)",
    fill: "#fd9600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M1148.271,26.539V32.2a3.286,3.286,0,0,1-.431,1.7,2.841,2.841,0,0,1-1.252,1.122,4.471,4.471,0,0,1-1.934.391,3.765,3.765,0,0,1-2.625-.861,3.07,3.07,0,0,1-.931-2.363V26.549h1.854V31.9a2.238,2.238,0,0,0,.411,1.482,1.7,1.7,0,0,0,1.342.471,1.669,1.669,0,0,0,1.322-.471,2.267,2.267,0,0,0,.411-1.492V26.549h1.854Z",
    transform: "translate(0.299 0)",
    fill: "#fd9600"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2",
    "data-name": "Rettangolo 2",
    width: 1.854,
    height: 8.742,
    transform: "translate(1150.653 26.549)",
    fill: "#fd9600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M1154.318,35.291V26.549h1.853v7.21h3.546v1.532Z",
    transform: "translate(0.302 0)",
    fill: "#fd9600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10",
    "data-name": "Tracciato 10",
    d: "M1163.6,35.291h-1.857v-7.2h-2.374V26.549h6.6v1.542H1163.6Z",
    transform: "translate(0.303 0)",
    fill: "#fd9600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    "data-name": "Tracciato 11",
    d: "M1177.593,30.835a4.445,4.445,0,0,1-1.172,3.315,4.664,4.664,0,0,1-3.386,1.142h-2.424V26.549h2.685a3.926,3.926,0,0,1,4.3,4.286Zm-1.072.04a3.5,3.5,0,0,0-.861-2.574,3.429,3.429,0,0,0-2.555-.871h-1.483v6.99h1.242a3.789,3.789,0,0,0,2.735-.891,3.547,3.547,0,0,0,.911-2.644Z",
    transform: "translate(0.306 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_12",
    "data-name": "Tracciato 12",
    d: "M1184.361,35.291h-4.878V26.549h4.878v.9h-3.856v2.814h3.626v.9h-3.626v3.216h3.856v.911Z",
    transform: "translate(0.309 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_13",
    "data-name": "Tracciato 13",
    d: "M1191.283,32.958a2.145,2.145,0,0,1-.841,1.8,3.628,3.628,0,0,1-2.274.651,5.645,5.645,0,0,1-2.394-.4v-.981a6.676,6.676,0,0,0,1.172.361,5.99,5.99,0,0,0,1.252.13,2.5,2.5,0,0,0,1.532-.391,1.266,1.266,0,0,0,.511-1.071,1.371,1.371,0,0,0-.18-.741,1.639,1.639,0,0,0-.611-.531,8.95,8.95,0,0,0-1.3-.561,4.147,4.147,0,0,1-1.742-1.031,2.281,2.281,0,0,1-.521-1.562,1.943,1.943,0,0,1,.761-1.612,3.155,3.155,0,0,1,2.013-.6,5.951,5.951,0,0,1,2.394.481l-.32.881a5.463,5.463,0,0,0-2.1-.451,2.03,2.03,0,0,0-1.262.35,1.142,1.142,0,0,0-.451.961,1.478,1.478,0,0,0,.17.741,1.612,1.612,0,0,0,.561.531,6.567,6.567,0,0,0,1.222.531,4.844,4.844,0,0,1,1.893,1.051,2.085,2.085,0,0,1,.521,1.462Z",
    transform: "translate(0.31 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_3",
    "data-name": "Rettangolo 3",
    width: 1.021,
    height: 8.742,
    transform: "translate(1193.284 26.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_14",
    "data-name": "Tracciato 14",
    d: "M1200.2,30.7h2.975v4.256a8.545,8.545,0,0,1-1.412.33,10.276,10.276,0,0,1-1.663.11A4.031,4.031,0,0,1,1197,34.219a4.652,4.652,0,0,1-1.1-3.315,4.974,4.974,0,0,1,.551-2.393,3.7,3.7,0,0,1,1.572-1.562,5.115,5.115,0,0,1,2.414-.541,6.649,6.649,0,0,1,2.6.511l-.391.9a5.91,5.91,0,0,0-2.284-.5,3.284,3.284,0,0,0-2.494.951,3.673,3.673,0,0,0-.9,2.634,3.791,3.791,0,0,0,.861,2.684,3.329,3.329,0,0,0,2.535.911,7.41,7.41,0,0,0,1.774-.21V31.6h-1.953v-.911Z",
    transform: "translate(0.313 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15",
    "data-name": "Tracciato 15",
    d: "M1211.991,35.291h-1.162l-4.778-7.34H1206c.06.861.1,1.652.1,2.363v4.965h-.941v-8.74h1.152l4.768,7.31h.05c0-.11-.03-.451-.05-1.041s-.04-1-.03-1.252V26.539H1212v8.74Z",
    transform: "translate(0.315 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16",
    "data-name": "Tracciato 16",
    d: "M1223.065,35.291l-1.092-2.784h-3.5l-1.082,2.784h-1.031l3.456-8.782h.851l3.436,8.782h-1.036Zm-1.4-3.7-1.021-2.714c-.13-.34-.27-.761-.411-1.262a10.9,10.9,0,0,1-.38,1.262l-1.031,2.714h2.844Z",
    transform: "translate(0.318 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_17",
    "data-name": "Tracciato 17",
    d: "M1232.129,35.291h-1.162l-4.778-7.34h-.05c.06.861.1,1.652.1,2.363v4.965h-.941v-8.74h1.152l4.768,7.31h.05c0-.11-.03-.451-.05-1.041s-.04-1-.03-1.252V26.539h.951v8.74Z",
    transform: "translate(0.321 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_18",
    "data-name": "Tracciato 18",
    d: "M1241.542,30.835a4.446,4.446,0,0,1-1.172,3.315,4.664,4.664,0,0,1-3.386,1.142h-2.424V26.549h2.685a4.318,4.318,0,0,1,3.175,1.13,4.263,4.263,0,0,1,1.132,3.154Zm-1.071.04a3.5,3.5,0,0,0-.861-2.574,3.43,3.43,0,0,0-2.555-.871h-1.482v6.99h1.242a3.789,3.789,0,0,0,2.735-.891,3.546,3.546,0,0,0,.911-2.644Z",
    transform: "translate(0.323 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19",
    "data-name": "Tracciato 19",
    d: "M1250.533,35.291l-2.965-7.751h-.05c.06.611.08,1.342.08,2.193v5.558h-.941V26.549h1.532l2.775,7.21h.05l2.795-7.21h1.522v8.742h-1.021V29.653c0-.651.03-1.352.08-2.1h-.05l-2.995,7.741h-.821Z",
    transform: "translate(0.326 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_20",
    "data-name": "Tracciato 20",
    d: "M1262.56,35.291h-4.878V26.549h4.878v.9H1258.7v2.814h3.626v.9H1258.7v3.216h3.856v.911Z",
    transform: "translate(0.329 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_21",
    "data-name": "Tracciato 21",
    d: "M1267.291,35.291h-1.021V27.45h-2.78v-.9h6.561v.9h-2.775v7.841Z",
    transform: "translate(0.331 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_22",
    "data-name": "Tracciato 22",
    d: "M1277.952,35.291h-1.021V31.179h-4.607V35.3H1271.3V26.549h1.021v3.715h4.607V26.549h1.021v8.742Z",
    transform: "translate(0.333 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23",
    "data-name": "Tracciato 23",
    d: "M1287.906,30.905a4.8,4.8,0,0,1-1.062,3.3,3.74,3.74,0,0,1-2.955,1.2,3.814,3.814,0,0,1-2.985-1.182,4.861,4.861,0,0,1-1.052-3.335,4.8,4.8,0,0,1,1.052-3.315A3.821,3.821,0,0,1,1283.9,26.4a3.7,3.7,0,0,1,2.945,1.192,4.855,4.855,0,0,1,1.062,3.312m-6.972,0a4.113,4.113,0,0,0,.761,2.694,3.082,3.082,0,0,0,4.359.037l.028-.027a4.231,4.231,0,0,0,.741-2.694,4.153,4.153,0,0,0-.741-2.674,2.633,2.633,0,0,0-2.184-.911,2.729,2.729,0,0,0-2.214.921,4.131,4.131,0,0,0-.761,2.674Z",
    transform: "translate(0.335 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_24",
    "data-name": "Tracciato 24",
    d: "M1296.869,30.835a4.445,4.445,0,0,1-1.172,3.315,4.664,4.664,0,0,1-3.386,1.142h-2.424V26.549h2.685a4.318,4.318,0,0,1,3.175,1.13,4.263,4.263,0,0,1,1.132,3.154Zm-1.071.04a3.5,3.5,0,0,0-.861-2.574,3.43,3.43,0,0,0-2.555-.871H1290.9v6.99h1.242a3.789,3.789,0,0,0,2.735-.891,3.547,3.547,0,0,0,.911-2.644Z",
    transform: "translate(0.338 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_25",
    "data-name": "Tracciato 25",
    d: "M1303.589,32.958a2.145,2.145,0,0,1-.841,1.8,3.628,3.628,0,0,1-2.274.651,5.646,5.646,0,0,1-2.394-.4v-.981a6.673,6.673,0,0,0,1.172.361,5.991,5.991,0,0,0,1.252.13,2.5,2.5,0,0,0,1.532-.391,1.266,1.266,0,0,0,.511-1.071,1.372,1.372,0,0,0-.18-.741,1.639,1.639,0,0,0-.611-.531,8.948,8.948,0,0,0-1.3-.561,4.148,4.148,0,0,1-1.743-1.031,2.282,2.282,0,0,1-.521-1.562,1.942,1.942,0,0,1,.761-1.612,3.156,3.156,0,0,1,2.014-.6,5.951,5.951,0,0,1,2.394.481l-.32.881a5.464,5.464,0,0,0-2.1-.451,2.03,2.03,0,0,0-1.262.35,1.142,1.142,0,0,0-.451.961,1.479,1.479,0,0,0,.17.741,1.612,1.612,0,0,0,.561.531,6.553,6.553,0,0,0,1.222.531,4.845,4.845,0,0,1,1.893,1.051,2.086,2.086,0,0,1,.521,1.462Z",
    transform: "translate(0.34 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBocconiHeaderWithLogo);
export default __webpack_public_path__ + "static/media/BocconiHeaderWithLogo.5d8d5c243aa51a2ce38ddb157d9effc6.svg";
export { ForwardRef as ReactComponent };